import React from 'react'

export default function TokenExpired({ brand }) {
  return (
    <div className="ob-error">
      <h1 className="zb-heading2">Your session has expired</h1>
      <div className="zb-card">
        <div className="zb-card-body">
          You have been logged out of the {brand.get('name')} access store.
          <br />
          Your log in details have not been saved and you can now close this
          page.
        </div>
      </div>
    </div>
  )
}
